import { BaseModel } from '/@/modules/core/app/models/abstracts/BaseModel';

export class StripePaymentMethodBillingDetails extends BaseModel {
  public email?: string;
  public name?: string;

  constructor(model: Partial<StripePaymentMethodBillingDetails> = {}) {
    super();

    this.email = model.email;
    this.name = model.name;
  }
}
